import { path } from "static-path";

const base = path("/v3");

const reportingApi = base.path("reporting");
const biodiversityApi = base.path("biodiversity");
const clientApi = base.path("client");
const clientsApi = base.path("clients");
const userApi = base.path("user/:userId");
const usersApi = base.path("users");
const investmentApi = base.path("investment");
const investmentsApi = base.path("investments");
const solutionsApi = base.path("solutions");
const solutionApi = base.path("solution");
const prospectsApi = base.path("prospects");
const projects = base.path("projects");
const staffViewStatesApi = base.path("staff/view-states");

const biodiversity = base.path("biodiversity");
const clients = base.path("clients");
const reporting = base.path("reporting");
const solutions = base.path("solutions");
const prospects = base.path("prospects");
const incidents = base.path("incidents");

export default {
  base,
  clients: {
    base: clients,
    new: clients.path("new"),
    view: clients.path("view/:id"),
  },
  biodiversity: {
    base: biodiversity,
  },
  users: {
    base: base.path("users"),
  },
  reporting: {
    base: reporting,
  },
  prospects: {
    base: prospects,
  },
  solutions: {
    base: solutions,
    view: solutions.path("view/:id"),
    new: solutions.path("new"),
  },
  api: {
    biodiversity: {
      base: biodiversityApi,
      units: biodiversityApi.path("units"),
    },
    client: {
      base: clientApi,
      add: clientApi,
      individual: clientApi.path(":id"),
      addImage: clientApi.path(":id/image"),
      addImageToNewClient: clientApi.path("image"),
    },
    clients: {
      base: clientsApi,
    },
    investment: {
      base: investmentApi,
      forClient: investmentApi.path(":clientId"),
      summary: investmentApi.path("summary/:clientId"),
    },
    investments: { updateNote: investmentsApi.path(":investmentId") },
    incidents: {
      base: incidents.path(":solutionId"),
    },
    projects: { forClient: projects.path("client/:clientId") },
    prospects: {
      base: prospectsApi,
    },
    reporting: {
      base: reportingApi,
      churnRate: reportingApi.path("churn"),
      investedClients: reportingApi.path("clients/names"),
      investedProjects: reportingApi.path("solutions/names"),
      unitsOfSale: reportingApi.path("sales/units-of-sale/total"),
    },
    solution: {
      base: solutionApi,
      individual: solutionApi.path(":id"),
      stripeLink: solutionApi.path(":id").path("stripe-link"),
    },
    solutions: {
      base: solutionsApi,
    },
    staffViewStates: {
      base: staffViewStatesApi,
      one: staffViewStatesApi.path(":name"),
    },
    user: {
      base: userApi,
      hubspotLink: userApi.path("/hubspot-link"),
      invite: userApi.path("/invite-email"),
      stripeLink: userApi.path("/stripe-link"),
    },
    users: usersApi,
  },
};
